class PromotionBanner extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const swiperEl = this.querySelector('.swiper');
    if (!swiperEl) return;

    const slides = swiperEl.querySelectorAll('.swiper-slide');
    if (slides.length <= 1) return;

    const speed = parseInt(this.dataset.autoplay, 10) || 4;

    this.carousel = new FoxTheme.Carousel(swiperEl, {
      slidesPerView: 1,
      loop: true,
      autoplay: {
        delay: speed * 1000,
        disableOnInteraction: false,
      },
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });

    if (this.carousel) this.carousel.init();
  }

  disconnectedCallback() {
    if (this.carousel && typeof this.carousel.destroy === 'function') {
      this.carousel.destroy();
    }
  }
}

customElements.define('promotion-banner', PromotionBanner);
